import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import UiContent from "../../Components/Common/UiContent";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FlashDatePicker from "../../Components/Common/FlashDatePicker";
import OverallWidget from "./OverallWidget";
import CaptureRateMealPeriod from "./CaptureRateMealPeriod";
import CaptureRateOccupancy from "./CaptureRateOccupancy";
import RevenueBreakdown from "./RevenueBreakdown";
import WeeklyPerformance from "./WeeklyPerformance";
import OccupancyHeatmap from "./OccupancyHeatmap";
import Loader from "../../Components/Common/Loader";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { getDateRangeByTimePeriod, displayDate, convertDateFormate, getDateByName } from "../../helpers/api_helper";
import WeeklyCalendar from "./WeeklyCalendar";
import CustomDatePicker from "../../Components/Common/CustomDatePicker";
import Flatpickr from "react-flatpickr";
import RevenueCoversChartStyled from "./RevenueBreakdownChart";

const CaptureRatio = () => {
  document.title = "KPI Dashboard | " + process.env.REACT_APP_NAME;
  const [refresh, setRefresh] = useState(false);

  const handleRefresh = () => {
    // setRecalculate(!recalculate);
    setRefresh(!refresh);
  }

  const [mealPeriod, setMealPeriod] = useState([]);
  const [currency, setCurrency] = useState('$');
  const [selectedMealList, setSelectedMealList] = useState(["all"]);
  const [selectedTime, setSelectedTime] = useState("day");
  const [selectedMetric, setSelectedMetric] = useState("");
  const [loading, setLoading] = useState(false);
  const [widgetData, setWidgetData] = useState([]);
  const [breakDownData, setBreakDownData] = useState([]);
  const [captureRateByMeal, setCaptureRateByMeal] = useState([]);
  const [captureRateOcc, setCaptureRateOcc] = useState([]);
  const [captureRateMealOcc, setCaptureRateMealOcc] = useState([]);
  const [weeklyReport, setWeeklyReport] = useState([]);

  const [leftCustomDate, setLeftCustomDate] = useState([]);
  const [leftFilter, setLeftFilter] = useState({
    label: "Yesterday",
    value: "Yesterday",
  });
  const [rightFilter, setRightFilter] = useState({ "label": "This Month", "value": "ThisMonth" });
  const [rightFilterToggle, setRightFilterToggle] = useState(false);
  const [comparisonDate, setComparisonDate] = useState([]);
  const [ordersTimeComparison, setOrdersTimeComparison] = useState([]);

  const timePeriods = [
    { value: "day", label: "Day" },
    { value: "week", label: "Week" },
    { value: "month", label: "Month" },
  ];

  const metrics = [
    { value: "ly", label: "LY" },
    { value: "budget", label: "Budget" },
    { value: "trend", label: "Trend" },
    { value: "forecast", label: "Forecast" },
    { value: "average", label: "Average" },
  ];

  const {
    currentOutlet,
    filterData,
    filterAjax,
  } = useSelector((state) => ({
    currentOutlet: state.UserOutletGroup.currentOutlet,
    filterData: state.Dashboard.filterData,
    filterAjax: state.Dashboard.filterAjax,
  }));

  useEffect(() => {
    if (filterData.date_compare) {
      setOrdersTimeComparison(filterData.date_compare);
    }
  }, [filterData]);

  // const [leftFilter, setLeftFilter] = useState(
  //   filterData.flash_date?.find((date) => date.default) || false
  // );

  useEffect(() => {
    if (currentOutlet?.currency !== "") {
      setCurrency(currentOutlet?.currency)
    }
  }, [currentOutlet]);



  let date = new Date();
  date.setDate(date.getDate() - 1);

  const changeDefaultComparison = (item) => {
    if (item.value !== 'Custom') {
      setRightFilterToggle(false);
    }
    setRightFilter(item);
  };

  useEffect(() => {
    if (
      (leftFilter.value !== "Custom" ||
        (leftFilter.value === "Custom" &&
          leftCustomDate[0] &&
          leftCustomDate[1])) &&
      (rightFilter.value !== "Custom" ||
        (rightFilter.value === "Custom" &&
          comparisonDate[0] &&
          comparisonDate[1]))
    ) {
      let leftFilterData =
        leftFilter.value === "Custom"
          ? {
            from: convertDateFormate(leftCustomDate[0]),
            to: convertDateFormate(leftCustomDate[1]),
          }
          : getDateByName(leftFilter.value);
      let rightFilterData =
        rightFilter.value === "Custom"
          ? {
            from: convertDateFormate(comparisonDate[0]),
            to: convertDateFormate(comparisonDate[1]),
          }
          : getDateByName(rightFilter.value);

      setLoading(true);
      const controller = new AbortController();
      //const leftFilter = getDateRangeByTimePeriod(selectedTime);
      //const leftFilter = {from_date:"2024-01-01", to_date:"2024-12-31"}
      postDataAPI({
        serviceName: "pms_data",
        op: "pms_widget",
        leftFilter: leftFilterData,
        //rightFilter: rightFilterData
      }, controller.signal).then((response) => {
        setLoading(false);
        if (response.status === "ok") {
          //console.log(response.data);
          const mealPeriodsTitles = (response.data.service_period).map(item => item.title);
          setMealPeriod(mealPeriodsTitles || []);
          setWidgetData(response.data.widget || []);
          setBreakDownData(response.data.revenue_breakdown || []);
          setCaptureRateByMeal(response.data.capture_rate_by_meal_period || []);
        }
      });

      postDataAPI({
        serviceName: "pms_data",
        op: "pms_captureratio_occ",
        leftFilter: leftFilterData,
        //rightFilter: rightFilterData
      }, controller.signal).then((response) => {
        setLoading(false);
        if (response.status === "ok") {
          //console.log(response.data);
          setCaptureRateOcc(response.data.capture_rate_by_meal_period || []);
        }
      });

      // postDataAPI({
      //     serviceName: "pms_data",
      //     op: "pms_weekly_performance_analysis",
      //     leftFilter: leftFilterData,
      //     rightFilter: rightFilterData
      // }).then((response) => {
      //     setLoading(false);
      //     if (response.status === "ok") {
      //         //console.log(response.data);
      //         setWeeklyPerformance(response.data);
      //     }
      // });

      postDataAPI({
        serviceName: "pms_data",
        op: "pms_mw_cr_occ_by_mealperiod",
        leftFilter: leftFilterData,
        //rightFilter: rightFilterData
      }, controller.signal).then((response) => {
        setLoading(false);
        if (response.status === "ok") {
          setCaptureRateMealOcc(response.data);
        }
      });

      postDataAPI({
        serviceName: "pms_data",
        op: "pms_weekly_capture_ratio_calendar",
        leftFilter: leftFilterData,
        //rightFilter: rightFilterData
      }, controller.signal).then((response) => {
        setLoading(false);
        if (response.status === "ok") {
          setWeeklyReport(response.data);
        }
      });
      return () => {
          controller.abort();
      };
    }
    
  }, [leftFilter, rightFilter, leftCustomDate, comparisonDate]);


  return (
    <React.Fragment>
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Capture Ratio"
            pageTitle="Dashboard"
            customDate={leftCustomDate}
            leftFilter={leftFilter}
            rightFilter={rightFilter}
            handleRefresh={handleRefresh}
          />

          <form className="mb-3">
            <Row>
              {/* <Col sm={12} lg={3}>
                    <div className="d-flex flex-wrap gap-2">
                    {timePeriods.map(period => (
                        <Button
                        key={period.value}
                        color={selectedTime === period.value ? "dark" : "outline-dark"}
                        onClick={() => setSelectedTime(period.value)}
                        >
                        {period.label}
                        </Button>
                    ))}
                    </div>
                </Col>

                <Col sm={12} lg={5}>
                    <div className="d-flex flex-wrap gap-2">
                    {metrics.map(metric => (
                        <Button
                        key={metric.value}
                        color={selectedMetric === metric.value ? "dark" : "outline-dark"}
                        onClick={() => setSelectedMetric(metric.value)}
                        >
                        {metric.label}
                        </Button>
                    ))}
                    </div>
                </Col> */}
              <Col className="mb-2 mb-lg-0 p-0" sm={12} lg={4}>
                <CustomDatePicker
                  activeDate={leftFilter}
                  setActiveDate={setLeftFilter}
                  customDate={leftCustomDate}
                  setCustomDate={setLeftCustomDate}
                  posEnd={false}
                />
              </Col>
              <Col className="mb-2 mb-lg-0" sm={12} lg={4}>
                {/* <UncontrolledDropdown isOpen={rightFilterToggle} toggle={() => { setRightFilterToggle(!rightFilterToggle); }}>
                    <DropdownToggle
                      type="button"
                      tag="button"
                      className="btn btn-outline-custom"
                    >
                      {rightFilter ? rightFilter.label+(rightFilter.label==='Custom'?displayDate(comparisonDate):'') : "Select Comparison"}
                      <span className="rightBox">
                        <span></span>
                        <svg
                          height="20"
                          width="20"
                          viewBox="0 0 20 20"
                          aria-hidden="true"
                          focusable="false"
                          className="css-tj5bde-Svg"
                        >
                          <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                        </svg>
                      </span>
                    </DropdownToggle>
                    <DropdownMenu className="custom-menu-width" end={true}>
                      <Row>
                        <Col
                          sm={
                            rightFilter
                              ? 4
                              : 12
                          }
                        >
                          {!filterAjax &&
                            ordersTimeComparison.length > 0 &&
                            ordersTimeComparison.map((item) => {
                              return (
                                <button
                                  key={item.value}
                                  onClick={() => changeDefaultComparison(item)}
                                  type="button"
                                  tabIndex="0"
                                  role="menuitem"
                                  className="dropdown-item"
                                >
                                  {item.label}
                                </button>
                              );
                            })}
                        </Col>
                        {rightFilter &&
                          rightFilter.label==='Custom' && (
                            <Col sm={8}>
                              <Flatpickr
                                className="form-control border-0 dash-filter-picker shadow mw-auto"
                                placeholder=""
                                value={comparisonDate}
                                onChange={([date, date2]) => {
                                  if(date !== undefined && date2 !== undefined){
                                    setRightFilterToggle(false);
                                  }
                                  setComparisonDate([date, date2]);
                                }}
                                options={{
                                  mode: "range",
                                  dateFormat: "d M, Y",
                                  inline: true,
                                }}
                              />
                            </Col>
                          )}
                      </Row>
                    </DropdownMenu>
                  </UncontrolledDropdown> */}
              </Col>

              <Col sm={12} lg={4}>
                    <div className="d-flex flex-wrap gap-2 justify-content-end">
                       {/* <Link to="/discount-dashboard">
                        <Button
                        className="btn btn-light btn-outline-dark"
                        key="discount"
                        
                        >
                        View Discount <i className="ri-arrow-right-line"></i>
                        </Button></Link> */}
                    </div>
                </Col>

            </Row>
          </form>

          <Row className="gx-4 gy-0">
            <Col xl={12}>
              <OverallWidget widgetData={widgetData} currency={currency} loading={loading} />
            </Col>

            <Col sm={12} lg={6} className='ps-0 pe-0 pe-lg-3'>
              <CaptureRateMealPeriod captureRateByMeal={captureRateByMeal} loading={loading} />
            </Col>

            <Col sm={12} lg={6} className='pe-0 ps-0 ps-lg-3'>
              <CaptureRateOccupancy captureRateOcc={captureRateOcc} loading={loading} />
            </Col>

            <Col sm={12} lg={12}>
              <RevenueCoversChartStyled mealPeriod={mealPeriod} breakDownData={breakDownData} loading={loading} />
            </Col>

            <Col sm={12} lg={12}>
              <WeeklyPerformance
                leftFilter={leftFilter}
                rightFilter={rightFilter}
                leftCustomDate={leftCustomDate}
                comparisonDate={comparisonDate}
              />
            </Col>

            <Col sm={12} lg={12}>
              <OccupancyHeatmap
                captureRateMealOcc={captureRateMealOcc}
                loading={loading}
                mealPeriod={mealPeriod}
              />
            </Col>

            <Col sm={12} lg={12}>
              <WeeklyCalendar
                weeklyReport={weeklyReport}
                loading={loading}
                currency={currency}
              />
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default CaptureRatio;
